import React from "react"
import PropTypes from "prop-types"
import './TextArea.css'

class TextArea extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      chars: props.value,
      hasTyped: false
    }
  }

  render () {
    const {textAreaClassName,name} = this.props

    return (
        <div className='field-text-area__wrapper'>
          <textarea className={`form-control ${textAreaClassName}`} onChange={this._onChange} name={name} value={this.state.chars}>
          </textarea>
          {this.state.hasTyped && this.props.showLengthValidator && <span className={this._charLengthCss()}>{this.state.chars.length}</span>}
        </div>
    );
  }

  _onChange = (e) => {
    this.setState({
      chars: e.target.value,
      hasTyped: true
    })
  }

  _charLengthCss = () => {
    const {minChars,maxChars} = this.props

    let valid = true
    valid = valid && this.state.chars.length >= minChars

    if (maxChars !== undefined){
      valid = valid && this.state.chars.length <= maxChars
    }

    if (valid) {
      return 'field-text-area__char_length_valid'
    } else {
      return 'field-text-area__char_length_invalid'
    }
  }
}

TextArea.propTypes = {
  minChars: PropTypes.number,
  maxChars: PropTypes.number,
  value: PropTypes.string,
  showLengthValidator: PropTypes.bool,
  textAreaClassName: PropTypes.string,
  name: PropTypes.string
}

TextArea.defaultProps = {
  minChars: 0,
  value: '',
  showLengthValidator: false
}

class RFTextArea extends React.Component {
  render () {
    const {textAreaClassName, input, meta} = this.props
    const {value} = input
    const {visited, touched,error} = meta
    //WTF BUG Redux form https://github.com/erikras/redux-form/issues/2174
    return (
        <div className={this._wrapperClassName()}>
          <textarea className={`form-control ${textAreaClassName}`}
                    onChange={this._onChange}
                    onBlur={input.onBlur}
                    onFocus={input.onFocus}
                    value={value}
          >
          </textarea>
          {visited && <span className='field-text-area__char_length'>{value.length}</span>}
          {touched && error && <span className={`form-control-feedback glyphicon glyphicon-remove`}/>}
          {touched && !error && <span className={`form-control-feedback glyphicon glyphicon-ok`} />}
          <span className='form-feedback'>{this._feedback()}</span>
        </div>
    );
  }

  _hasErrorFeedback = () => {
    const {meta: {touched, error}} = this.props
    return touched && error
  }


  _feedback = () => {
    const {feedback, meta: {error}} = this.props
    if (this._hasErrorFeedback()) {
      return error
    } else if (feedback){
      return feedback
    } else {
      return ''
    }
  }

  _wrapperClassName = () => {
    const {feedback, meta: {touched, error}} = this.props
    let messageFeedback = ''
    if (this._hasErrorFeedback()){
      messageFeedback = error
    } else {
      messageFeedback = feedback
    }
    return  `field-text-area__wrapper ${messageFeedback && 'has-feedback'} ${touched && !error && 'has-success'} ${this._hasErrorFeedback() && 'has-error'}`
  }

  _onChange = (e) => {
    const {input: {onChange}} = this.props
    onChange(e)
  }
}

export {RFTextArea}

export default TextArea



// WEBPACK FOOTER //
// app/javascript/components/fields/TextArea/TextArea.js